export enum EbetJoinMethod {
  InPerson = "InPerson",
  ViaMail = "ViaMail",
  Online = "Online",
}

export const EbetJoinMethodList = () =>
  Object.entries(EbetJoinMethod).map(([label, value]) => {
    return { label: value, value: label };
  });
